import React from 'react';
import PropTypes from 'prop-types';

export default class LotItemMedia extends React.PureComponent {

    render() {
        let mainImageSrcSet = this.props.image;

        return (
            <div className="lot-item__media">
                <div className="lot-item__img">
                    {mainImageSrcSet ?
                        <img data-srcset={mainImageSrcSet} data-sizes="auto"
                                      className="lazyload" alt=""/> : null}
                    <a href={this.props.url}/>
                </div>
            </div>
        );
    }
}

LotItemMedia.propTypes = {
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
};





// WEBPACK FOOTER //
// ./app/components/lot-item/js/LotItemMedia.js